type CompatibleTagNames = 'iframe' | 'img';

export class LazyElement {
  private container: HTMLElement;
  private el?: HTMLIFrameElement | HTMLImageElement;
  public onLoad = undefined as (() => void) | undefined;

  constructor(private src: string, readonly id?: string) {
    this.container = (id && document.getElementById(id)) || document.body;
  }

  public mount(tagName: CompatibleTagNames, style?: React.CSSProperties) {
    this.el = document.createElement(tagName);
    this.el.src = this.src;
    style && Object.assign(this.el.style, style);
    this.el.onload = this.onLoad ?? null;

    this.container.appendChild(this.el);
  }

  public unmount() {
    if (!this.el) {
      console.error('LazyElement is not mounted');
      return;
    }

    this.container.removeChild(this.el);
  }
}
